import script from "./UserPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPage.vue?vue&type=script&lang=ts&setup=true"

import "./UserPage.vue?vue&type=style&index=0&id=301670e7&lang=scss"

const __exports__ = script;

export default __exports__